interface FAQItem {
  id: number;
  question: string;
  answer: string;
}

interface FAQCategoryProps {
  title: string;
  items: FAQItem[];
  expandedId: number | null;
  onToggle: (id: number) => void;
}

export default function FAQCategory({ title, items, expandedId, onToggle }: FAQCategoryProps) {
  return (
    <div className="mb-8">
      <h2 className="font-headline text-2xl font-bold text-primary mb-4">{title}</h2>
      <div className="space-y-3">
        {items.map((item) => (
          <div
            key={item.id}
            className="bg-card border border-border rounded-lg overflow-hidden shadow-subtle transition-brand hover:shadow-brand"
          >
            <button
              onClick={() => onToggle(item.id)}
              className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-muted transition-brand"
              aria-expanded={expandedId === item.id}
            >
              <span className="font-body font-semibold text-foreground pr-4">
                {item.question}
              </span>
              <svg
                className={`w-5 h-5 text-primary flex-shrink-0 transition-transform ${
                  expandedId === item.id ? 'rotate-180' : ''
                }`}
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M19 9l-7 7-7-7"
                />
              </svg>
            </button>
            {expandedId === item.id && (
              <div className="px-6 pb-4 pt-2 border-t border-border bg-muted/30">
                <p className="font-body text-muted-foreground leading-relaxed">
                  {item.answer}
                </p>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}